<template>
  <div class="relative">
    <!-- SVG Map with event handlers -->
    <div class="relative">
      <svg class="absolute z-10 inset-0 overflow-visible w-full" viewBox="0 0 547 312" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          v-for="region in regions"
          :id="region.id"
          :key="region.id"
          :d="region.path"
          :class="[
            'region',
            selectedRegionId === region.id ? 'region--active' : ''
          ]"
        />
      </svg>
      <svg class="relative w-full" viewBox="0 0 547 312" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.11523 90.1228L7.32991 82.5571L17.5976 100.661L21.3805 87.4208L36.2417 74.451L57.3175 68.2363L67.5852 74.451L89.7419 82.5571L95.146 114.981L66.7746 134.977L33.8098 136.598L6.7895 106.335L1.11523 90.1228Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M118.113 37.1628L143.782 35.2714L151.348 26.6249H162.426L185.934 15.0061L177.287 9.33187L175.936 0.955566H185.934L202.146 5.00862L204.578 22.0314L191.338 28.5163L183.232 43.9179L191.338 65.2639L181.881 85.5292L152.699 86.3398L148.106 93.3651L128.381 99.3096L104.603 115.792L95.1457 114.981L89.7416 82.557L67.585 74.4509L75.6911 63.1023L111.088 50.4028L118.113 37.1628Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M183.232 43.9179L191.339 28.5164L204.578 22.0315L229.437 22.8421L233.76 2.30664L255.917 7.4405L256.998 21.2209L275.102 32.2992L282.667 66.0746L265.104 71.4787L244.569 64.7236L227.005 53.3751L216.467 65.264H191.339L183.232 43.9179Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M282.667 66.0747L275.101 32.2993L313.2 45.2691L315.632 54.456L333.195 45.8095L347.786 55.5368L328.061 74.451L342.652 82.5571L360.215 112.009L338.329 125.519H327.251L314.011 116.603L295.096 110.118L268.076 118.224L262.672 96.0673L242.947 86.34L244.568 64.7237L265.104 71.4788L282.667 66.0747Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M411.554 151.729L406.96 130.383L420.741 91.7439L432.63 97.148L451.544 88.5015L455.327 100.39L441.276 108.497L446.951 115.522L452.895 114.981L463.973 131.194L479.375 125.79L475.592 120.656L479.105 118.764L486.67 126.87L493.425 127.141L523.148 137.678L546.115 174.156L543.683 188.477L520.446 191.989L512.61 202.797L501.802 190.909L471.809 186.585L449.382 161.727L411.554 151.729Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M371.023 129.843L376.428 129.032L382.912 105.254L395.612 101.471L394.261 91.7439L386.155 87.6908L382.912 74.1807L402.367 78.7741L420.741 91.7439L406.96 130.383L411.554 151.729L449.382 161.727L471.809 186.585L446.68 198.204L408.852 221.441L401.286 206.31L389.127 194.151L388.316 201.717L382.642 208.472L373.725 187.666L378.589 180.911L382.642 167.941L373.996 144.974L371.023 129.843Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M344.814 183.073L378.589 180.911L373.725 187.666L382.642 208.472L388.316 201.717L389.127 194.151L401.286 206.31L408.852 221.442L405.88 245.49L425.334 256.838L449.923 273.861L429.387 278.184L417.498 272.24L406.69 280.076L394.261 302.503L388.316 290.884L379.4 292.775L369.132 281.967L354.541 278.725L345.624 289.803L324.278 288.452L311.038 282.237L300.771 272.24L290.503 276.023L276.993 267.376L309.957 250.083L323.468 252.515L335.627 242.517L332.925 224.144L344.543 209.282L344.814 183.073Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M408.852 221.442L446.681 198.204L471.809 186.585L501.802 190.909L512.61 202.798L505.315 213.876L493.966 217.118L487.481 241.167L482.888 250.353H472.89L467.216 264.134L449.923 273.861L425.335 256.838L405.88 245.49L408.852 221.442Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M272.129 148.757L306.715 169.833L314.011 165.239L344.814 183.073L344.543 209.282L332.925 224.144L335.627 242.788L323.468 252.515L310.228 250.083L276.993 267.376L270.778 256.838L276.993 240.626L224.573 218.199L226.194 189.558L252.134 176.588L251.323 162.807L272.129 148.757Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M131.623 189.557L172.964 184.964L226.195 189.557L224.573 218.199L276.993 240.626L270.778 256.838L276.993 267.376L256.457 257.378L247.541 263.053L243.217 256.838L234.301 254.136L231.058 257.378L231.599 269.808L227.005 285.209L219.98 282.507L207.551 296.558L205.659 309.798L199.174 302.502L187.285 299.8L174.316 311.419L151.889 301.421L145.134 288.992L135.406 283.318L112.439 256.838L116.492 240.356L125.409 230.088L131.623 189.557Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M171.073 116.062L180.26 114.17L191.609 109.037L207.28 117.953L205.929 130.923L195.662 129.302L178.369 136.327L175.396 126.6L171.073 116.062Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M244.568 64.7236L242.947 86.3398L262.672 96.0674L268.076 118.224L262.672 126.33L274.832 137.138L272.129 148.757L251.324 162.808L252.134 176.588L226.195 189.558L172.964 184.964L131.624 189.558L124.598 166.59L135.676 159.295L136.757 138.759L104.603 115.792L128.381 99.3096L148.106 93.3652L152.699 86.3398L181.881 85.5293L191.338 65.2637H216.467L227.005 53.375L244.568 64.7236ZM180.26 114.171L171.073 116.062L175.396 126.6L178.369 136.327L195.662 129.302L205.929 130.924L207.281 117.953L191.609 109.037L180.26 114.171Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M268.076 118.224L295.096 110.118L314.01 116.602L327.25 125.519H338.329L360.215 112.009L369.402 116.602L378.859 105.254H382.912L376.427 129.032L371.023 129.842L373.996 144.974L382.642 167.941L378.589 180.911L344.814 183.072L314.01 165.239L306.715 169.832L272.129 148.757L274.831 137.138L262.672 126.33L268.076 118.224Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
        <path d="M66.7745 134.976L95.1459 114.981L104.603 115.792L136.757 138.759L135.676 159.295L124.598 166.59L131.623 189.558L125.409 230.088L116.492 240.356L112.439 256.838L105.143 259.81L94.0651 238.194L82.4463 235.222L66.7745 209.823L41.9158 195.232L35.9713 174.967L21.3804 157.133L33.8097 136.598L66.7745 134.976Z" fill="white" fill-opacity="0.05" stroke="#828283"/>
      </svg>
    </div>

    <!-- Region Tooltip -->
    <div
      v-if="selectedRegion"
      :class="['tooltip', `tooltip--${selectedRegionId}`]"
      :style="tooltipPosition"
    >
      <div class="tooltip__gradient-border">
        <div class="tooltip__content text-center font-bold">
          <div v-if="title" class="text-xs">{{ title }}</div>
          <div class="tooltip__price text-xl">{{ prize }}</div>
          <div class="text-base">{{ formatedPsc }}</div>
        </div>
      </div>
      <div class="tooltip__pin"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";

const props = defineProps({
  lastDraw: {type: Object as PropType<GameDrawLocal>, required: false},
  isLoading: {type: Boolean, required: false, default: false},
})

const currency = useCurrency()

const prize = computed(() => {
  return currency.toCurrency((props.lastDraw?.prize || 0) + (props.lastDraw?.accumulatedPrize || 0))
})

const title = computed(() => {
  return props.lastDraw?.game?.name
})

const formatedPsc = computed(() => {
  const psc = props.lastDraw?.winningPsc
  if (!psc) {
    return psc
  }
  return `${psc?.substring(0, 3)} ${psc?.substring(3, 5)}`
})

const selectedRegion = computed(() => {
  return regions.find((region) => {
    return region.id === props.lastDraw?.region?.code
  })
})

const selectedRegionId = computed(() => {
  return selectedRegion.value?.id
})

const tooltipPosition = computed(() => {
  if (!selectedRegion.value) return {}

  return {
    left: `${selectedRegion.value?.position.x}%`,
    top: `${selectedRegion.value?.position.y}%`
  }
})

const regions = [
  {
    id: "51",
    name: "Karlovarský kraj",
    path: "M1.11523 90.1228L7.32991 82.5571L17.5976 100.661L21.3805 87.4208L36.2417 74.451L57.3175 68.2363L67.5852 74.451L89.7419 82.5571L95.146 114.981L66.7746 134.977L33.8098 136.598L6.7895 106.335L1.11523 90.1228Z",
    position: { x: 10, y: 40 }
  },
  {
    id: "60",
    name: "Ústecký kraj",
    path: "M118.113 37.1628L143.782 35.2714L151.348 26.6249H162.426L185.934 15.0061L177.287 9.33187L175.936 0.955566H185.934L202.146 5.00862L204.578 22.0314L191.338 28.5163L183.232 43.9179L191.338 65.2639L181.881 85.5292L152.699 86.3398L148.106 93.3651L128.381 99.3096L104.603 115.792L95.1457 114.981L89.7416 82.557L67.585 74.4509L75.6911 63.1023L111.088 50.4028L118.113 37.1628Z",
    position: { x: 26, y: 27 }
  },
  {
    id: "78",
    name: "Liberecký kraj",
    path: "M183.232 43.9179L191.339 28.5164L204.578 22.0315L229.437 22.8421L233.76 2.30664L255.917 7.4405L256.998 21.2209L275.102 32.2992L282.667 66.0746L265.104 71.4787L244.569 64.7236L227.005 53.3751L216.467 65.264H191.339L183.232 43.9179Z",
    position: { x: 45, y: 20 }
  },
  {
    id: "86",
    name: "Královéhradecký kraj",
    path: "M282.667 66.0747L275.101 32.2993L313.2 45.2691L315.632 54.456L333.195 45.8095L347.786 55.5368L328.061 74.451L342.652 82.5571L360.215 112.009L338.329 125.519H327.251L314.011 116.603L295.096 110.118L268.076 118.224L262.672 96.0673L242.947 86.34L244.568 64.7237L265.104 71.4788L282.667 66.0747Z",
    position: { x: 55, y: 35 }
  },
  {
    id: "132",
    name: "Moravskoslezský kraj",
    path: "M411.554 151.729L406.96 130.383L420.741 91.7439L432.63 97.148L451.544 88.5015L455.327 100.39L441.276 108.497L446.951 115.522L452.895 114.981L463.973 131.194L479.375 125.79L475.592 120.656L479.105 118.764L486.67 126.87L493.425 127.141L523.148 137.678L546.115 174.156L543.683 188.477L520.446 191.989L512.61 202.797L501.802 190.909L471.809 186.585L449.382 161.727L411.554 151.729Z",
    position: { x: 85, y: 55 }
  },
  {
    id: "124",
    name: "Olomoucký kraj",
    path: "M371.023 129.843L376.428 129.032L382.912 105.254L395.612 101.471L394.261 91.7439L386.155 87.6908L382.912 74.1807L402.367 78.7741L420.741 91.7439L406.96 130.383L411.554 151.729L449.382 161.727L471.809 186.585L446.68 198.204L408.852 221.441L401.286 206.31L389.127 194.151L388.316 201.717L382.642 208.472L373.725 187.666L378.589 180.911L382.642 167.941L373.996 144.974L371.023 129.843Z",
    position: { x: 75, y: 65 }
  },
  {
    id: "116",
    name: "Jihomoravský kraj",
    path: "M344.814 183.073L378.589 180.911L373.725 187.666L382.642 208.472L388.316 201.717L389.127 194.151L401.286 206.31L408.852 221.442L405.88 245.49L425.334 256.838L449.923 273.861L429.387 278.184L417.498 272.24L406.69 280.076L394.261 302.503L388.316 290.884L379.4 292.775L369.132 281.967L354.541 278.725L345.624 289.803L324.278 288.452L311.038 282.237L300.771 272.24L290.503 276.023L276.993 267.376L309.957 250.083L323.468 252.515L335.627 242.517L332.925 224.144L344.543 209.282L344.814 183.073Z",
    position: { x: 68, y: 80 }
  },
  {
    id: "141",
    name: "Zlínský kraj",
    path: "M408.852 221.442L446.681 198.204L471.809 186.585L501.802 190.909L512.61 202.798L505.315 213.876L493.966 217.118L487.481 241.167L482.888 250.353H472.89L467.216 264.134L449.923 273.861L425.335 256.838L405.88 245.49L408.852 221.442Z",
    position: { x: 85, y: 75 }
  },
  {
    id: "408",
    name: "Kraj Vysočina",
    path: "M272.129 148.757L306.715 169.833L314.011 165.239L344.814 183.073L344.543 209.282L332.925 224.144L335.627 242.788L323.468 252.515L310.228 250.083L276.993 267.376L270.778 256.838L276.993 240.626L224.573 218.199L226.194 189.558L252.134 176.588L251.323 162.807L272.129 148.757Z",
    position: { x: 53, y: 70 }
  },
  {
    id: "35",
    name: "Jihočeský kraj",
    path: "M131.623 189.557L172.964 184.964L226.195 189.557L224.573 218.199L276.993 240.626L270.778 256.838L276.993 267.376L256.457 257.378L247.541 263.053L243.217 256.838L234.301 254.136L231.058 257.378L231.599 269.808L227.005 285.209L219.98 282.507L207.551 296.558L205.659 309.798L199.174 302.502L187.285 299.8L174.316 311.419L151.889 301.421L145.134 288.992L135.406 283.318L112.439 256.838L116.492 240.356L125.409 230.088L131.623 189.557Z",
    position: { x: 35, y: 80 }
  },
  {
    id: "19",
    name: "Praha",
    path: "M171.073 116.062L180.26 114.17L191.609 109.037L207.28 117.953L205.929 130.923L195.662 129.302L178.369 136.327L175.396 126.6L171.073 116.062Z",
    position: { x: 35, y: 47 }
  },
  {
    id: "27",
    name: "Středočeský kraj",
    path: "M244.568 64.7236L242.947 86.3398L262.672 96.0674L268.076 118.224L262.672 126.33L274.832 137.138L272.129 148.757L251.324 162.808L252.134 176.588L226.195 189.558L172.964 184.964L131.624 189.558L124.598 166.59L135.676 159.295L136.757 138.759L104.603 115.792L128.381 99.3096L148.106 93.3652L152.699 86.3398L181.881 85.5293L191.338 65.2637H216.467L227.005 53.375L244.568 64.7236ZM180.26 114.171L171.073 116.062L175.396 126.6L178.369 136.327L195.662 129.302L205.929 130.924L207.281 117.953L191.609 109.037L180.26 114.171Z",
    position: { x: 40, y: 40 }
  },
  {
    id: "94",
    name: "Pardubický kraj",
    path: "M268.076 118.224L295.096 110.118L314.01 116.602L327.25 125.519H338.329L360.215 112.009L369.402 116.602L378.859 105.254H382.912L376.427 129.032L371.023 129.842L373.996 144.974L382.642 167.941L378.589 180.911L344.814 183.072L314.01 165.239L306.715 169.832L272.129 148.757L274.831 137.138L262.672 126.33L268.076 118.224Z",
    position: { x: 60, y: 53 }
  },
  {
    id: "43",
    name: "Plzeňský kraj",
    path: "M66.7745 134.976L95.1459 114.981L104.603 115.792L136.757 138.759L135.676 159.295L124.598 166.59L131.623 189.558L125.409 230.088L116.492 240.356L112.439 256.838L105.143 259.81L94.0651 238.194L82.4463 235.222L66.7745 209.823L41.9158 195.232L35.9713 174.967L21.3804 157.133L33.8097 136.598L66.7745 134.976Z",
    position: { x: 15, y: 60 }
  }
]
</script>